import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { DateRangePicker } from 'react-dates';
import withStyles from 'isomorphic-style-loader/withStyles';
import 'react-dates/initialize';

import { isRTL } from '../../../helpers/formatLocale';

import s from 'react-dates/lib/css/_datepicker.css';
import c from '../../../styles/reactDatesCalendar.css';

class PaymentDateRangePicker extends React.Component {
  static propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    numberOfMonths: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
      startDate: props.startDate ? moment(props.startDate) : null,
      endDate: props.endDate ? moment(props.endDate) : null
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { startDate, endDate } = nextProps;
    this.setState({
      startDate: startDate ? moment(startDate) : null,
      endDate: endDate ? moment(endDate) : null,
    });
  }

  onDatesChange = ({ startDate, endDate }) => {
    const { onChange } = this.props;
    this.setState({ startDate, endDate });

    onChange({
      startDate: startDate ? moment(startDate).format("YYYY-MM-DD") : '',
      endDate: endDate ? moment(endDate).format("YYYY-MM-DD") : ''
    });
  }

  onFocusChange = (focusedInput) => {
    this.setState({ focusedInput });
  }

  render() {
    const { focusedInput, startDate, endDate } = this.state;
    const { smallDevice, numberOfMonths } = this.props;
    const { formatMessage } = this.props.intl;
    const { locale } = this.props;

    return (
      <DateRangePicker
        onDatesChange={this.onDatesChange}
        onFocusChange={this.onFocusChange}
        focusedInput={focusedInput}
        startDate={startDate}
        endDate={endDate}
        numberOfMonths={smallDevice ? 1 : numberOfMonths || 1}
        startDatePlaceholderText="From"
        endDatePlaceholderText="To"
        hideKeyboardShortcutsPanel
        readOnly
        startDateId={'paymentStartDateId'}
        endDateId={'paymentEndDateId'}
        transitionDuration={0}
        anchorDirection={isRTL(locale) ? 'right' : 'left'}
        isRTL={isRTL(locale)}
        small
        displayFormat="DD/MM/YYYY"
        showClearDates={true}
        showDefaultInputIcon={true}
        isOutsideRange={() => false}
      />
    );
  }
}

const mapState = state => ({
  locale: state.intl.locale,
  smallDevice: state.toggle.smallDevice
});

const mapDispatch = {};

export default injectIntl(withStyles(s, c)(connect(mapState, mapDispatch)(PaymentDateRangePicker)));
